// extracted by mini-css-extract-plugin
module.exports = {"ripple":"loader_ripple__3hzrx","lds-ripple":"loader_lds-ripple__3Si3Z"};